var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KModal",
    {
      attrs: {
        title: _vm.title,
        submitText: _vm.coreString("deleteAction"),
        cancelText: _vm.coreString("cancelAction"),
      },
      on: {
        submit: function ($event) {
          return _vm.$emit("submit", { deleteEverywhere: _vm.deleteEverywhere })
        },
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c(
        "div",
        [
          _vm.numberOfResources === 1
            ? [
                _c("p", [
                  _vm._v(_vm._s(_vm.$tr("confirmationQuestionOneResource"))),
                ]),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$tr("deleteEverywhereExplanationOneResource"))
                  ),
                ]),
              ]
            : [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$tr("confirmationQuestionMultipleResources"))
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$tr("deleteEverywhereExplanationMultipleResources")
                    )
                  ),
                ]),
              ],
          _c("KCheckbox", {
            attrs: { label: _vm.$tr("deleteEverywhereLabel") },
            on: {
              change: function ($event) {
                _vm.deleteEverywhere = $event
              },
            },
            model: {
              value: _vm.deleteEverywhere,
              callback: function ($$v) {
                _vm.deleteEverywhere = $$v
              },
              expression: "deleteEverywhere",
            },
          }),
          _c("p", [_vm._v(_vm._s(_vm.coreString("cannotUndoActionWarning")))]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }